// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop-sidebar{
    position: fixed;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    height: 100%;
    max-width: 288px;
    background-color: var(--app-secondary-bg-color);
    align-items: flex-start;
    top: 0;
    bottom: 0;
    padding: 0 10px 31px;
    box-sizing: border-box;
}

.desktop-sidebar--opened{
    width: 100%;
}

.desktop-sidebar--closed{
    z-index: 10;
    align-items: center;
    padding-bottom: 17px;
}

.desktop-sidebar--closed .MuiIconButton-root.menu-icon-btn__list-item .menu-icon-btn__icon{
    padding: 0;
}

.desktop-sidebar__header{
    padding-top: 39px;
    padding-bottom: 2px;
}

.desktop-sidebar__header-add-icon-btn.MuiIconButton-root:hover{
    background-color: transparent;
}

.desktop-sidebar__header-logo img{
    height: 30px;
}

.desktop-sidebar__header--opened{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
}

.desktop-sidebar__header--opened a.menu-list__item{
    width: auto!important;

}

.desktop-sidebar__header--opened a.menu-list__item .menu-icon-btn__icon{
    padding: 0;
    margin: 0;
}

.desktop-sidebar__header--opened a.menu-list__item .menu-icon-btn__icon:before{
    line-height: 1.5;
}

.desktop-sidebar__header--opened .menu-list__item{
    width: auto;
}

.desktop-sidebar__menu-container{
    -ms-overflow-x: hidden;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 60px);
    align-items: self-start;
    overscroll-behavior: contain;
    padding-top: 12px;
    padding-left: 12px;
    padding-right: 12px;
    /*mozilla*/
    scrollbar-width: thin;
}

.desktop-sidebar__menu-container .menu-list__item {
    min-height: 52px;
    display: flex;
    align-items: center;
}

.desktop-sidebar__menu-container .menu-list__item {
    min-height: 52px;
    display: flex;
    align-items: center;
}

.desktop-sidebar__menu-container::-webkit-scrollbar{
    display: none;
}

.desktop-sidebar__header-notifications-btn.MuiIconButton-root{
    color: var(--app-text-color-primary);
    padding: 0;
}

@media screen and (min-width: 1120px) {
    .desktop-sidebar__menu-container{
        padding-left: 12px;
        padding-right: 12px;
    }

    .inline-label-menu-button__icon-container{
        padding: 5px 16px 3px 5px;
    }
}

@media screen and (max-height: 560px) {
    .desktop-sidebar__menu-container::before {
        content: '';
        position: absolute;
        top: 74px;
        width: 100%;
        background: linear-gradient(#f6f6f6,rgba(246, 246, 246, 0));
        left: 0;
        padding-top: 16px;
        text-align: center;
        z-index: 1;
    }

    .desktop-sidebar__menu-container::after {
        content: '';
        position: absolute;
        bottom: 16px;
        width: 100%;
        background: linear-gradient(rgba(246, 246, 246, 0), #f6f6f6);
        left: 0;
        padding-top: 16px;
        z-index: 1;
    }
}

@media screen and (max-height: 520px) and (min-width: 1125px) {
    .desktop-sidebar__menu-container::after {
        bottom: 28px;
    }
}

@media screen and (min-height: 620px) {
    .desktop-sidebar__menu-container{
        padding-top: 12px;
    }
}

.sidebar-header-menu__user-preferences--closed{
    margin: 0 auto;
    padding-top: 10px;
    padding-bottom: 10px;
}

.inline-label-menu-button-sidebar-menu-item{
    padding: 12px;
}

.inline-label-menu-button-sidebar-secondary-color .inline-label-menu-button__label{
    color:var(--app-fill-color-primary-one)!important;
}

.inline-label-menu-button-sidebar-secondary-color .inline-label-menu-button__icon-container svg path {
    fill:var(--app-fill-color-primary-one)!important;
}

.inline-label-menu-button-sidebar-default-color .inline-label-menu-button__label{
    color:var(--app-text-color-primary)!important;
}

.inline-label-menu-button-sidebar-default-color .inline-label-menu-button__icon-container svg path {
    fill:var(--app-text-color-primary)!important;
}

.extra-service-menu-icon{
    width: 18px;
    height: 18px;
}

.inline-label-menu-button__label.custom-menu-button__label{
    padding-left: 0!important;
}

.inline-label-menu-button__icon-button.MuiIconButton-root:hover{
    background: none!important;
}
`, "",{"version":3,"sources":["webpack://./src/core/components/menu/SideBar/styles/SideBar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,+CAA+C;IAC/C,uBAAuB;IACvB,MAAM;IACN,SAAS;IACT,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,2DAA2D;QAC3D,OAAO;QACP,iBAAiB;QACjB,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,4DAA4D;QAC5D,OAAO;QACP,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".desktop-sidebar{\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    height: 100%;\n    max-width: 288px;\n    background-color: var(--app-secondary-bg-color);\n    align-items: flex-start;\n    top: 0;\n    bottom: 0;\n    padding: 0 10px 31px;\n    box-sizing: border-box;\n}\n\n.desktop-sidebar--opened{\n    width: 100%;\n}\n\n.desktop-sidebar--closed{\n    z-index: 10;\n    align-items: center;\n    padding-bottom: 17px;\n}\n\n.desktop-sidebar--closed .MuiIconButton-root.menu-icon-btn__list-item .menu-icon-btn__icon{\n    padding: 0;\n}\n\n.desktop-sidebar__header{\n    padding-top: 39px;\n    padding-bottom: 2px;\n}\n\n.desktop-sidebar__header-add-icon-btn.MuiIconButton-root:hover{\n    background-color: transparent;\n}\n\n.desktop-sidebar__header-logo img{\n    height: 30px;\n}\n\n.desktop-sidebar__header--opened{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n}\n\n.desktop-sidebar__header--opened a.menu-list__item{\n    width: auto!important;\n\n}\n\n.desktop-sidebar__header--opened a.menu-list__item .menu-icon-btn__icon{\n    padding: 0;\n    margin: 0;\n}\n\n.desktop-sidebar__header--opened a.menu-list__item .menu-icon-btn__icon:before{\n    line-height: 1.5;\n}\n\n.desktop-sidebar__header--opened .menu-list__item{\n    width: auto;\n}\n\n.desktop-sidebar__menu-container{\n    -ms-overflow-x: hidden;\n    overflow-x: hidden;\n    display: flex;\n    flex-direction: column;\n    max-height: calc(100vh - 60px);\n    align-items: self-start;\n    overscroll-behavior: contain;\n    padding-top: 12px;\n    padding-left: 12px;\n    padding-right: 12px;\n    /*mozilla*/\n    scrollbar-width: thin;\n}\n\n.desktop-sidebar__menu-container .menu-list__item {\n    min-height: 52px;\n    display: flex;\n    align-items: center;\n}\n\n.desktop-sidebar__menu-container .menu-list__item {\n    min-height: 52px;\n    display: flex;\n    align-items: center;\n}\n\n.desktop-sidebar__menu-container::-webkit-scrollbar{\n    display: none;\n}\n\n.desktop-sidebar__header-notifications-btn.MuiIconButton-root{\n    color: var(--app-text-color-primary);\n    padding: 0;\n}\n\n@media screen and (min-width: 1120px) {\n    .desktop-sidebar__menu-container{\n        padding-left: 12px;\n        padding-right: 12px;\n    }\n\n    .inline-label-menu-button__icon-container{\n        padding: 5px 16px 3px 5px;\n    }\n}\n\n@media screen and (max-height: 560px) {\n    .desktop-sidebar__menu-container::before {\n        content: '';\n        position: absolute;\n        top: 74px;\n        width: 100%;\n        background: linear-gradient(#f6f6f6,rgba(246, 246, 246, 0));\n        left: 0;\n        padding-top: 16px;\n        text-align: center;\n        z-index: 1;\n    }\n\n    .desktop-sidebar__menu-container::after {\n        content: '';\n        position: absolute;\n        bottom: 16px;\n        width: 100%;\n        background: linear-gradient(rgba(246, 246, 246, 0), #f6f6f6);\n        left: 0;\n        padding-top: 16px;\n        z-index: 1;\n    }\n}\n\n@media screen and (max-height: 520px) and (min-width: 1125px) {\n    .desktop-sidebar__menu-container::after {\n        bottom: 28px;\n    }\n}\n\n@media screen and (min-height: 620px) {\n    .desktop-sidebar__menu-container{\n        padding-top: 12px;\n    }\n}\n\n.sidebar-header-menu__user-preferences--closed{\n    margin: 0 auto;\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n\n.inline-label-menu-button-sidebar-menu-item{\n    padding: 12px;\n}\n\n.inline-label-menu-button-sidebar-secondary-color .inline-label-menu-button__label{\n    color:var(--app-fill-color-primary-one)!important;\n}\n\n.inline-label-menu-button-sidebar-secondary-color .inline-label-menu-button__icon-container svg path {\n    fill:var(--app-fill-color-primary-one)!important;\n}\n\n.inline-label-menu-button-sidebar-default-color .inline-label-menu-button__label{\n    color:var(--app-text-color-primary)!important;\n}\n\n.inline-label-menu-button-sidebar-default-color .inline-label-menu-button__icon-container svg path {\n    fill:var(--app-text-color-primary)!important;\n}\n\n.extra-service-menu-icon{\n    width: 18px;\n    height: 18px;\n}\n\n.inline-label-menu-button__label.custom-menu-button__label{\n    padding-left: 0!important;\n}\n\n.inline-label-menu-button__icon-button.MuiIconButton-root:hover{\n    background: none!important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
